import {CustomerBlackList} from "../../domain/model/customer_black_list";

interface IGetCustomerBlackListResponse {
    customerBlackList: CustomerBlackList | null;
}
class GetCustomerBlackListResponse implements IGetCustomerBlackListResponse{
    public customerBlackList: CustomerBlackList | null;
}

interface IAddCustomerBlackListResponse {
    customerBlackList: CustomerBlackList | null;
}
class AddCustomerBlackListResponse implements IAddCustomerBlackListResponse{
    public customerBlackList: CustomerBlackList | null;
}

interface IDeleteCustomerBlackListResponse {
    customerBlackList: CustomerBlackList | null;
}
class DeleteCustomerBlackListResponse implements IDeleteCustomerBlackListResponse{
    public customerBlackList: CustomerBlackList | null;
}

export {
    GetCustomerBlackListResponse,
    AddCustomerBlackListResponse,
    DeleteCustomerBlackListResponse,
}


// WEBPACK FOOTER //
// ./src/presentation/response/customer_black_list_response.ts